import {Component, Input} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {ConfigRouteEnum} from "../../enums/config-route.enum";
import {RouterLink, UrlTree} from "@angular/router";

@Component({
    selector: 'du-config-amount-badges',
    imports: [
        TranslateModule,
        RouterLink,
    ],
    templateUrl: './config-amount-badges.component.html',
    styleUrl: './config-amount-badges.component.scss'
})
export class ConfigAmountBadgesComponent {
    @Input() badges: {amount: string, label: string, icon?: string, routerLink: any[] | string | UrlTree | null | undefined}[] = []
    @Input() direction: 'row' | 'column' = 'column'

    protected readonly ConfigRouteEnum = ConfigRouteEnum;
}
